import React, { useEffect } from 'react';
import './Toast.css';

/**
 * Toast notification component for displaying temporary messages
 * Used for rate limiting feedback, errors, and success messages
 */
function Toast({ message, type = 'info', duration = 3000, onClose }) {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  return (
    <div className={`toast toast-${type}`}>
      <div className="toast-icon">
        {type === 'error' && '⚠️'}
        {type === 'warning' && '⏰'}
        {type === 'success' && '✅'}
        {type === 'info' && 'ℹ️'}
      </div>
      <div className="toast-message">{message}</div>
      <button className="toast-close" onClick={onClose}>
        ✕
      </button>
    </div>
  );
}

/**
 * Toast container component for managing multiple toasts
 */
function ToastContainer({ toasts, removeToast }) {
  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
}

export { Toast, ToastContainer };
export default Toast;
